import React from 'react'
import { View } from 'styles/reactnative'

import { Switch } from 'antd'
import { column_group } from '../../../components/AdminUserModal/UserInfoTabs/column_coingroup'
import { column_pairs_status } from '../../../components/AdminUserModal/UserInfoTabs/column_pairs_status'
import TableAPI from '../../../components/TableAPI'

const CoinGroup = ({ title, type }: any) => {
	const [search, setSearch] = React.useState('')
	const [isall, setIsall] = React.useState<any>(0)
	return (
		<View style={{ width: '100%' }}>
			{/* <TableAPI
				title={'조기마감'}
				columns={column_group}
				usermodal={true}
				height={'default'}
				apikey={`/admin/coingroup?${
					search ? 'type=user_id&searchWord=' + search : 't='
				}`}
			/> */}
			<TableAPI
				title={title}
				columns={column_group}
				usermodal={true}
				height={'default'}
				apikey={`/admin/coingroup?${
					search ? 'type=user_id&searchWord=' + search : 't='
				}`}
			/>
			<TableAPI
				title={title}
				columns={column_pairs_status}
				extra={
					<>
						<Switch
							checked={isall}
							onChange={e => setIsall(e ? 1 : 0)}
						/>{' '}
						전체보기
					</>
				}
				usermodal={false}
				height={false}
				apikey={`/admin/exchangepairs?ov=1&${isall ? `dev=${1}&` : ''}${
					search ? 'type=user_id&searchWord=' + search : 't='
				}`}
				sharemutate={`/admin/ovs?${
					search ? 'type=symbol&searchWord=' + search : 't='
				}`}
			/>
		</View>
	)
}

export default React.memo(CoinGroup)
